export const sell_part = {
  title: "Sell a Part",

  step_account: "Company Details",
  step_part: "Part Details",

  company_details_title: "Company Details",

  company_name_label: "Company Name",
  company_name_placeholder: "Your company name",
  dba_label: "Doing Business As (DBA)",
  dba_placeholder: "Enter your DBA name",

  company_address_title: "Company Address",

  /** Line parts: "Contacting us as **{name}** <{email}> with phone number {phone}. …" */
  contact_line_lead: "You are contacting us as",
  contact_line_with_phone: "with phone number",
  contact_line_tail: "You can update these in your",
  settings_link: "account settings",

  session_not_set: "—",

  verify_alert:
    "Please verify your email address before submitting a sell request. Check your inbox for the verification message, or request a new code.",
  verify_link: "Resend or enter verification code",

  next: "Next",
  back: "Back",
  submit: "Submit Request",

  part_details_title: "Part Details",

  part_description_label: "Describe the part(s) you would like to sell",
  part_description_placeholder:
    "e.g., GE Frame 7FA combustion liner, serviceable condition, removed at 24,000 hours.",

  submit_error: "Something went wrong. Please try again.",

  submit_success_snackbar:
    "Request received. Our team will contact you within 1-2 business days.",

  company_save_error:
    "We could not save your company details. Please try again.",

  address_incomplete:
    "Please complete all address fields: street, city/town, state/region, country, and postal code.",
};
